import { BKJButton, BKJLoadingSpinner } from '@bookjane2/bookjane-design-library';
import { Flex } from 'components/Flex';
import { H3, P } from 'components/Typography';
import { useTranslation } from 'hooks/useTranslation';
import { SKILLS_SETTINGS_PATH } from 'pages/Settings/pages/Organization/SkillsPage/SkillsPage.constants';
import {
  CenteredCell,
  EmptyStateMessage,
  SkillsTableRow,
  SkillsTableScrollArea,
} from 'pages/Settings/pages/Organization/SkillsPage/SkillsPage.styled';
import { LocationAllocationCell } from 'pages/Settings/pages/Organization/SkillsPage/LocationAllocationCell';
import { SkillLocationsAllocationModal } from 'pages/Settings/pages/Organization/SkillsPage/SkillLocationsAllocationModal';
import { OrganizationSkill } from 'pages/Settings/pages/Organization/SkillsPage/store/organizationSkills.store.types';
import { useOrganizationSkillsStore } from 'pages/Settings/pages/Organization/SkillsPage/store/organizationSkills.store';
import { SettingsPageWrapper } from 'pages/Settings/SettingsPage.styled';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import isUserSecondarySelector from 'store/selectors/userSelectors/isUserSecondarySelector';

export const SkillsPageReadView: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const isUserSecondary = useSelector(isUserSecondarySelector);
  const skills = useOrganizationSkillsStore((state) => state.skills);
  const isLoading = useOrganizationSkillsStore((state) => state.isLoading);
  const [allocationSkill, setAllocationSkill] = useState<OrganizationSkill | null>(null);

  return (
    <SettingsPageWrapper>
      <Flex flexDirection="column" width="100%" maxWidth="900px">
        <Flex justifyContent="space-between" alignItems="flex-start" margin="0 0 40px 0">
          <H3>{t('settings:SKILLS')}</H3>
          {!isUserSecondary && (
            <BKJButton
              variant="PurpleOutlined"
              width="192px"
              minWidth="192px"
              onClick={() => history.push(`${SKILLS_SETTINGS_PATH}/edit`)}
            >
              {t('settings:EDIT')}
            </BKJButton>
          )}
        </Flex>
        <Flex flexDirection="column" gap="32px">
          <Flex maxWidth="672px">
            <P>{t('settings:SKILLS_PAGE_NOTE')}</P>
          </Flex>
          {isLoading && (
            <Flex justifyContent="center" padding="40px 0">
              <BKJLoadingSpinner variant="Default" />
            </Flex>
          )}
          {!isLoading && !skills.length && (
            <EmptyStateMessage>{t('settings:NO_SKILLS_MESSAGE')}</EmptyStateMessage>
          )}
          {!isLoading && !!skills.length && (
            <SkillsTableScrollArea>
              <SkillsTableRow $isHeader>
                {t('settings:SKILLS')}
                <CenteredCell>{t('location_settings:LOCATION_ALLOCATION')}</CenteredCell>
              </SkillsTableRow>
              {skills.map((skill) => (
                <SkillsTableRow key={skill.id}>
                  {skill.name}
                  <LocationAllocationCell
                    count={skill.communitiesSkills.length}
                    onClick={() => setAllocationSkill(skill)}
                  />
                </SkillsTableRow>
              ))}
            </SkillsTableScrollArea>
          )}
        </Flex>
      </Flex>
      <SkillLocationsAllocationModal
        skill={allocationSkill}
        onClose={() => setAllocationSkill(null)}
      />
    </SettingsPageWrapper>
  );
};
